export const rotateAround = (arr, fulcrum) => {
  const fulcrumIndex = arr.indexOf(fulcrum);
  return fulcrumIndex === -1 ? arr : arr.slice(fulcrumIndex).concat(arr.slice(0, fulcrumIndex));
};
export const includes = (list, item) => list.includes(item);